import React, { useContext, useEffect, useState } from "react";
import Box from "@mui/material/Box";
import { MsalContext } from "../../Contexts/MsalContext";
import { APIContext } from "../../Contexts/APIContext"
import Grid from "@mui/material/Grid";
import MonitoringCallInfoBody from "../../Monitoring/MonitoringCallInfo/MonitoringCallInfoBody";
import Paper from "@mui/material/Paper";
import Notes from "../../CallInfo/Notes";
import Button from "@mui/material/Button";
import FeedbackRowViewModel from "../ViewModels/FeedbackRowViewModel";
import FeedbackPageTitleBar from "../Shared/FeedbackPageTitleBar";

const styles = {
    fullHeight: {
        height: '100%'
    },
    bgColour: {
        backgroundColor: 'rgb(245, 245, 245)'
    }
};

interface IProps {
    callRefId: string;
    completeId: number;
    close: () => void;
    agentView?: boolean;
    systemId: string;
}

export default function AgentFeedbackPage(props: IProps) {
    const { get } = useContext(APIContext);
    const { msalFetch } = useContext(MsalContext);
    const [feedback, setFeedback] = useState<FeedbackRowViewModel | null>(null);
    const [pdf, setpdf] = useState<string>('0');

    useEffect(() => {
        getFeedback();
        pdfDownload()
    }, [props.callRefId]);

    const getFeedback = () => {
        get('Feedback', `GetFeedback?completeId=${props.completeId}`, (data) => setFeedback(data));
    }

    const acknowledgeFeedback = () => {
        get('Feedback', `AgentAcknowledgeFeedback?completeId=${props.completeId}`, () => {
            getFeedback();
        });
    }

    const pdfDownload = () => {
        msalFetch(`api/PDFGenerator/CreateScorecardPDF?completeId=${props.completeId}`)
            .then(response => response.blob())
            .then(data => {
                console.log(data)
                if (data.type !== "application/problem+json") {
                    var url = window.URL.createObjectURL(data);
                    setpdf(url);
                }
                else {
                    console.log('error', 'An internal server error occured');
                }
            })
            .catch(e => {
                console.log(e);
            });
    }

    return (
        feedback &&
        <Box display="flex" sx={{ ...styles.fullHeight, ...styles.bgColour }} flexDirection="column"  >
            <Box flexGrow={1} overflow="auto">
                <Grid container sx={styles.fullHeight}>
                    <Grid size={6} sx={styles.fullHeight}>
                        <Grid container spacing={1}>
                            <FeedbackPageTitleBar callRefId={props.callRefId} close={props.close} />
                            <Grid size={12}>
                                <Paper>
                                    <Notes systemPK={props.callRefId} monitoring={true} />
                                </Paper>
                            </Grid>
                            {
                                !feedback.dateAgentResponded &&
                                <Grid size={12}>
                                    <Button
                                        variant='contained'
                                        color='secondary'
                                        fullWidth
                                        onClick={() => acknowledgeFeedback()}>
                                        Acknowledge Feedback
                                    </Button>
                                </Grid>
                            }
                            <Grid size={12}>
                                    <MonitoringCallInfoBody id={props.callRefId} systemId={ props.systemId} />
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={6} sx={{ height: '100%', overflow: 'hidden' }}>
                            {pdf !== '0' && <object width="100%" height="100%" data={pdf + "#toolbar=0"} type="application/pdf" />}
                    </Grid>
                </Grid >
            </Box>
        </Box >
    );
}